import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Logo } from '../components/branding/Logo';

export function AuthLayout() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-2 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  // Redirect to app if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/app/home" replace />;
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header with branding */}
      <header className="pt-12 pb-8 px-6 text-center hidden md:flex flex-col items-center">
        <Logo className="h-16" />
      </header>

      {/* Main content */}
      <main className="flex-1 px-6 pt-8 pb-8 md:pt-0">
        <Outlet />
      </main>
    </div>
  );
}
